// extracted by mini-css-extract-plugin
export default {"tripcoinIconCircle":"HwIMx","tripcoinIconText":"NXn7v"};